import {translate} from "../../../../i18n";
import getRuleError from "../utils/getRuleError";
import getRuleValue from "../utils/getRuleValue";
import {
    createDomainRegex,
    createEmailRegex,
    createUrlRegex,
    createVietnamesePhoneRegex
} from "../../../../regex/common";
import getRequiredError from "../utils/getRequiredError";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired() || checkMinLength() || checkMaxLength() || checkBlackList() || checkMatch();
}

function checkRequired() {
    if ($value !== '') {
        return null;
    }

    return getRequiredError($rules, $options, $allValues);
}

function checkMinLength() {
    if ($value === '') {
        return null;
    }

    const {minLength} = $rules;

    if (minLength === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(minLength, $allValues);

    if ($value.length >= ruleValue) {
        return null;
    }

    return getRuleError(minLength, $allValues, translate('min_characters{number}', {number: ruleValue}));
}

function checkMaxLength() {
    if ($value === '') {
        return null;
    }

    const {maxLength} = $rules;

    if (maxLength === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(maxLength, $allValues);

    if ($value.length <= ruleValue) {
        return null;
    }

    return getRuleError(maxLength, $allValues, translate('max_characters{number}', {number: ruleValue}));
}

function checkBlackList() {
    if ($value === '') {
        return null;
    }

    const {blackList} = $rules;

    if (blackList === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(blackList, $allValues);

    if (!ruleValue.includes($value)) {
        return null;
    }

    return getRuleError(blackList, $allValues, translate('Not allowed'));
}

function checkMatch() {
    if ($value === '') {
        return null;
    }

    const {match} = $rules;

    if (match === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(match, $allValues);

    const [regex, defaultError] = parseRegex(ruleValue);

    if (!regex || $value.match(regex) !== null) {
        return null;
    }

    return getRuleError(match, $allValues, defaultError);
}

function parseRegex(ruleValue) {
    if (ruleValue instanceof RegExp) {
        return [ruleValue, translate('Invalid')];
    }

    switch (ruleValue) {
        case 'url':
            return [createUrlRegex(), translate('Invalid URL')];
        case 'email':
            return [createEmailRegex(), translate('Invalid email')];
        case 'domain':
            return [createDomainRegex(), translate('Invalid domain name')];
        case 'vietnamesePhone':
            return [createVietnamesePhoneRegex(), translate('Invalid phone number')];
    }

    return [null, null];
}
